export default __webpack_public_path__ + "static/broadband-f43dc6a0d6ca27c16eb99b0aa3b96871.webp";